import React from 'react';
import { NotificationsForm } from 'forms';
import { routeConstants } from 'routes';
import { SettingsContent, SettingsContentLayout, SettingsPageHeader } from './components';

// TODO: Add a prop to Notifications form for where the missing contact method URL sends you to
// it would go back a step in this page

const NotificationsSettings = () => (
  <>
    <SettingsContent data-cy="account-settings-container">
      <SettingsPageHeader />

      <SettingsContentLayout>
        <NotificationsForm missingMethodURL={routeConstants.private.settingsAccount} />
      </SettingsContentLayout>
    </SettingsContent>
  </>
);

export default NotificationsSettings;
